import type { SVGProps } from "react";

export default function ResetIcon(props: SVGProps<SVGSVGElement>) {
  const { width = 21, height = 19, ...rest } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.07272 6.36473L3.82936 9.12134C3.89182 9.18384 3.99315 9.18384 4.05557 9.12134L6.81225 6.36473C6.96342 6.21356 6.85635 5.95509 6.64256 5.95509H1.24241C1.02862 5.95509 0.921547 6.21356 1.07272 6.36473Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.76953 5.95508C5.08434 3.03391 8.02047 1 11.4317 1C16.0701 1 19.8302 4.76012 19.8302 9.39844C19.8302 14.0368 16.0701 17.7969 11.4317 17.7969C9.11258 17.7969 7.01301 16.8569 5.4932 15.3371"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
